import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { format } from "date-fns";
import { Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Snackbars from "./Snackbars";

const ConfirmTicket = () => {
  const { qrcode_id } = useParams();
  const navigate = useNavigate();
  const [details, setdetails] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openModule, setOpenModule] = useState(false);
  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const proceedConfirm = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        "app-token": process.env.REACT_APP_TOKEN_SECRET,
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/v1/scanner/ticket-used/${qrcode_id}`,
        { headers: headers }
      );
      const res = response.data;

      if (res.code === 200) {
        navigate(`/confirmed`);
      } else {
        setAlertData({
          variant: "error",
          message: res.message,
        });
        resetAlertData();
      }
    } catch (error) {
      setAlertData({
        variant: "error",
        message: "Something went Wrong.",
      });
      resetAlertData();
    }
  };
  const proceedCancel = async () => {
    navigate(`/`);
  };

  const handleConfirm = async () => {
    setOpen(true);
    setOpenModule("confirm");
  };

  const handleCancel = async () => {
    setOpen(true);
    setOpenModule("cancel");
  };

  const TicketData = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        "app-token": process.env.REACT_APP_TOKEN_SECRET,
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/v1/scanner/ticket-details/${qrcode_id}`,
        { headers: headers }
      );
      const res = response.data;

      if (res.code === 200) {
        if (res.data) {
          setdetails(res.data);
        } else {
          setAlertData({
            variant: "error",
            message: "Ticket details not found!",
          });
          resetAlertData();
        }
      } else {
        setAlertData({
          variant: "error",
          message: res.message,
        });
        resetAlertData();
      }
    } catch (error) {
      setAlertData({
        variant: "error",
        message: "Something went Wrong.",
      });
      resetAlertData();
    }
  };

  useEffect(() => {
    TicketData();
  }, []);

  const formatEventDate = (start, end, time, ticketDate) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInMs = endDate - startDate; // Difference in milliseconds
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // Convert to days
    const day = `${diffInDays + 1}`.toLowerCase();

    const startDay = format(startDate, "dd");
    const endDay = format(endDate, "dd");
    const endmonth = format(endDate, "MMMM");
    const startmonth = format(startDate, "MMMM");
    const year = format(startDate, "yyyy");
    let daysCount = day;
    if (day > 1) {
      daysCount = "10";
    }

    const ticket_date = new Date(ticketDate);
    const ticketDay = format(ticket_date, "dd");

    if (startDay == endDay) {
      return {
        formattedDate: `${startDay} ${startmonth} ${year}`,
        daysCount: `${daysCount} Day's Event`,
        time,
        ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
      };
    }

    return {
      formattedDate: `${startDay} ${startmonth} - ${endDay} ${endmonth} ${year}`,
      daysCount: `${daysCount} Day's Event`,
      time,
      ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
    };
  };

  if (!details) return <div></div>;
  const { formattedDate, daysCount, time, ticketFormatedDate } =
    formatEventDate(
      details.start_datetime,
      details.end_datetime,
      details.start_time + " - " + details.end_time,
      details.event_ticket_date
    );

  return (
    <>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="confirm-page">
        <div className="confirm-container">
          <img
            src={details.banner}
            alt="Logo"
            width={300}
            style={{ marginBottom: "10px" }}
          />
          <div className="ticket-details">
            <h4>Event:</h4> <p>{details.name}</p>
            <br />
            <br />
            <h4>Pass:</h4>{" "}
            <p>{`${details.type} Ticket, ${details.day_pass} Day Pass, ${details.quantity} Person`}</p>
            <br />
            <br />
            <h4>Date:</h4>{" "}
            <p>
              {details.day_pass == 1
                ? ticketFormatedDate + ", " + time
                : formattedDate + ", " + time}
            </p>
            <br />
            <br />
            <h4>Address:</h4> <p>{details.address}</p>
            <br />
            <br />
            {details.is_seats_required === "Yes" ? (
              <>
                <h4>Seat No:</h4>
                <p>{details.booked_seat}</p>
                <br />
                <br />
              </>
            ) : ''}

            <h4>Buying Price: ₹</h4> <p>{`${details.purchase_price}`}</p>
            <br />
            <br />
            <h4>Available Tickets: </h4> <p>{`${details.quantity-details.allready_resale_ticket}`}</p>
            <br />
            <br />
            <h4>Resell Tickets: </h4> <p>{`${details.allready_resale_ticket}`}</p>
          </div>
          <button
            onClick={handleConfirm}
            disabled={loading}
            className="otp-button"
          >
            {loading ? "Processing..." : "Confirm"}
          </button>

          <button
            onClick={handleCancel}
            disabled={resendLoading}
            className="resend-button"
          >
            {resendLoading ? "Redirecting..." : "Cancel"}
          </button>

          <Dialog open={open} onClose={() => setOpen(false)}>
            <div
              className="install-modal"
              style={{
                zIndex: 111,
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  background: "white",
                  padding: "25px 10px 30px",
                  borderRadius: "10px",
                  textAlign: "center",
                  width: "100%",
                  maxWidth: "430px",
                  margin: "0 10px",
                  position: "relative", // Needed for absolute positioning of close button
                }}
              >
                {/* Close Button */}
                <button
                  onClick={() => setOpen(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <CloseIcon style={{ fontSize: "24px", color: "#555" }} />
                </button>

                {openModule === "confirm" ? (
                  <p style={{ fontSize: "20px", marginTop: "8px" }}>
                    Are you sure you want to confirm?
                  </p>
                ) : (
                  <p style={{ fontSize: "20px", marginTop: "8px" }}>
                    Are you sure you want to cancel?
                  </p>
                )}

                {openModule === "confirm" ? (
                  <button
                    id="submit1"
                    onClick={proceedConfirm}
                    style={{
                      background: "#28a745",
                      border: "none",
                      padding: "4px 25px",
                      fontSize: "18px",
                      color: "#fff",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Confirm
                  </button>
                ) : (
                  <button
                    onClick={proceedCancel}
                    style={{
                      marginLeft: "10px",
                      background: "#EFEFEF",
                      border: "none",
                      padding: "4px 25px",
                      fontSize: "18px",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                )}
              </div>
            </div>
          </Dialog>
        </div>
      </div>
    </>
  );
};

export default ConfirmTicket;
